(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_typeDialogController', Campagna_typeDialogController);

    Campagna_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna_type'];

    function Campagna_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna_type) {
        var vm = this;

        vm.campagna_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna_type.id !== null) {
                Campagna_type.update(vm.campagna_type, onSaveSuccess, onSaveError);
            } else {
                Campagna_type.save(vm.campagna_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagna_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
